import compose from "recompose/compose";
import withProps from "recompose/withProps";
import { getConfig } from "@gqlapp/base/utils/RenderBase";

export default  compose(
  withProps(getConfig),
	withProps((props: any)=>{
		let { autocompleteProps, options, onInputChange, getOptionLabel  } = props

		getOptionLabel = getOptionLabel || ((opt: any) => typeof opt === 'string' ? opt : opt?.value);

		autocompleteProps = Object.assign({}, { getOptionLabel, options: options || [], onInputChange }, autocompleteProps);

		return { autocompleteProps }
	}),
	withProps((props: any)=>{
		let { className, placeholder, label, type, required, variant, margin, fullWidth, input, onChange} = props
		let { size, shrink, autoComplete, autocompleteProps, onFocus, onOpen, freeSolo, disabled } = props
		let { noOptionsText, filterSelectedOptions, includeInputInList, renderOption, filterOptions } = props
		let { InputLabelProps, InputProps, value }: any = input;

		autocompleteProps = Object.assign({}, {
			disabled, autoComplete, freeSolo, onOpen, onFocus, onChange, noOptionsText, value, defaultValue: value
		}, autocompleteProps);

		autocompleteProps = Object.assign({},  {
			filterSelectedOptions, includeInputInList, filterOptions, renderOption,
		}, autocompleteProps);

		let controlProps = {
			placeholder: placeholder || label || '', disabled,
		}

		controlProps = Object.assign({}, controlProps, {
			label, variant, margin, fullWidth, required, className,
		});

		controlProps = Object.assign({}, controlProps, {
			type, InputLabelProps, size: size || 'small', shrink,
		});

		return { InputProps, controlProps, input: autocompleteProps }
	})
);
